import 'vue/jsx'
import 'virtual:uno.css' // 引入unocss
import 'virtual:svg-icons-register' // 导入全局的svg图标
import 'animate.css' // 引入animate动画
import { setupStore } from '@/store' // 引入状态管理
import { setupI18n } from '@/plugins/vueI18n' // 初始化多语言
import { setupRouter } from './router' // 路由

import { setupGlobCom } from '@/components' // 全局组件
import { setupUIFramework } from '@/plugins/uiFramework' // 引入ui框架
import { setupDirective } from '@/utils/directives' // 引入自定义指令

import '@/styles/index.less' // 引入全局重置样式
import '@/styles/common.less' // 引入全局公共样式
import { createApp } from 'vue'
import App from './App.vue'

import './permission'

const setupArr = [setupStore, setupGlobCom, setupUIFramework, setupRouter, setupDirective]
// 创建实例
const setupAll = async () => {
  const app = createApp(App)
  await setupI18n(app)
  setupArr.forEach((fn) => fn(app))
  app.mount('#app')
}

setupAll()
